import { ChangeEvent, FC, useEffect, useState } from "react"
import Plus from '../../assets/FrequentQuestions/plus.png';

const Order: FC = () => {
  const [filePath, setFilePath] = useState<string| null>(null);
  const [email, setEmail] = useState<string>('');
  const [orderSentMessage, setOrderSentMessage] = useState<string | null>(null);
  const [comment, setComment] = useState<string>('');
  const [file,setFile] = useState<string | Blob | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [isEmail, setIsEmail] = useState<boolean>(false);
  const [isFileInvalid, setIsFileInvalid] = useState<boolean>(false);
  const [fileToLarge, setFileToLarge] = useState<boolean>(false);
  const fileRegex = /pdf|dwg|doc|docx|dotm|dotx|odt|rtf|txt|wps|xml|xps|csv|dbf|dif|ods|xls|xlsx|xla|xlam|xlsm|bmp|jpg|jpeg|png|pptx|potx|ppsx|ppt|tif|dxf/gm;
  const emailRegex= /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const isSubmitButtonDisable = comment.length === 0 || loading || !isEmail || isFileInvalid || fileToLarge
  const sendOrder = async (body: FormData) => {
    try {
      const resp = await fetch('https://django.skatled.ru/api/v1/email', {
        method: 'POST',
        body: body,
        referrer: 'http://localhost:3000',
        referrerPolicy: 'origin',
      });
      const message: any = await resp.json();
      setOrderSentMessage(message.detail);
      setTimeout(() => setOrderSentMessage(null), 5000);
    } catch (e) {
      setOrderSentMessage('Загружаемый файл слишком большой')
      setTimeout(() => setOrderSentMessage(null), 5000);
    }
  }
  let formData = new FormData();

  function validateSize(input: ChangeEvent<HTMLInputElement>) {
    if (input.target.files) {
      const fileSize = input.target.files[0].size / 1024 / 1024;
      if (fileSize > 5) {
        setOrderSentMessage('Размер файла слишком большой');
        setFileToLarge(true);
      }
    }
  }

  const onSubmitButton = async () => {
    if (email && comment) {
      formData.append('email', email);
      formData.append('comment', comment);
      if (file) formData.append('file', file);
      setLoading(true);
      await sendOrder(formData);
      setComment('');
      setEmail('');
      const input = document.querySelector('#file')
      setFilePath('');
      if (input !== null) {
        // @ts-ignore
        input.value = null;
      }
      setLoading(false);
    }
    // @ts-ignore
    ym(54548461,'reachGoal','application');
    return true;
  }

  useEffect(() => {
    if (filePath) setIsFileInvalid(filePath.split("\\")[2].match(fileRegex) === null);
  },[filePath])

  return (
    <div className='container order' id='order'>
      <div className="row order__title"><h1>Заказать светотехнический расчет</h1></div>
      <div className="row order__form">
        <p>Email</p>
        <input
          type="email"
          value={email}
          className='form-email'
          onChange={(e) => {
            setIsEmail(e.target.value.match(emailRegex) !== null);
            setEmail(e.target.value);
          }}
        />
        {email.length > 0 && !isEmail && (<p className='form-email__warning'>Введите верный email</p>)}
        <p>Комментарий</p>
        <textarea className='form-text' value={comment} onChange={(e) => {
          setComment(e.target.value);
        }} />
        <input type="file" accept=".pdf,.dwg,.pdf,.dwg,.doc,.docx,.dotm,.dotx,.odt,.rtf,.txt,.wps,.xml,.xps,.csv,.dbf,.dif,.ods,.xls,.xlsx,.xla,.xlam,.xlsm,.bmp,.jpg,.jpeg,.png,.pptx,.potx,.ppsx,.ppt,.tif,.dxf" id="file" className='form-file' onChange={(e) => {
          validateSize(e);
          // @ts-ignore
          setFile(e.target.files[0]);
          setFilePath(e.target.value);
        }} />
        {filePath && filePath.length !== 0 && (
          <div className="form-delete-file">
            <img src={Plus} alt="" onClick={() => {
              const input = document.querySelector('#file')
              setFilePath(null);
              setIsFileInvalid(false);
              setOrderSentMessage(null);
              setFileToLarge(false);
              if (input !== null) {
                // @ts-ignore
                input.value = null;
              }

            }} />
            <p>{filePath.split('\\')[2]}</p>
          </div>
        )}
        {filePath && <p className='file-warning'>{isFileInvalid && "Неверное расширение файла"}</p>}
        {orderSentMessage !== null && (
          <div className="form-message">
            <p>{orderSentMessage}</p>
          </div>
        )}
      </div>
      <div className={`row order__button ${loading && 'loading'}`}>
        <button
          disabled={isSubmitButtonDisable}
          className={isSubmitButtonDisable ? 'disabled' : undefined}
          onClick={onSubmitButton}>{loading ? "Отправка...": "Отправить"}
        </button>
      </div>
    </div>
  )
}

export default Order;
